import React from "react";
import {
  compose,
  withProps,
  toClass,
  withHandlers,
  defaultProps,
  renameProp,
  mapProps
} from "recompose";
import * as R from "ramda";
import { Placeholder } from "@worcket/common/components/feedback";
import { Button as AntdButton } from "antd";
import { useTranslation } from "react-i18next";

import Button from "../Button";

import styled from "styled-components/macro";

const Container = styled.div`
  width: 100%;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  ${({ lineSeparator }) =>
    lineSeparator &&
    `
      &:not(:last-of-type) {
        border-bottom: 1px solid #e8e8e8;
      }
    `};
`;

const Multi = ({
  values,
  children,
  disableAdd,
  disabled,
  onUpdate,
  onRemove,
  onAdd,
  deleteBtnStyle,
  addBtnStyle,
  rowStyle,
  lineSeparator,
  keyExtractor,
  ...props
}) => {
  const { t } = useTranslation();
  return (
    <Container>
      {values &&
        values.map((value, index) => (
          <Row
            lineSeparator={lineSeparator}
            style={rowStyle}
            key={keyExtractor(value, index)}
          >
            {React.cloneElement(children, {
              ...props,
              index,
              value,
              onChange: value => onUpdate(index, value)
            })}
            {!disabled && (
              <AntdButton
                // TODO change for our own button
                icon="delete"
                style={{ marginLeft: 8, ...deleteBtnStyle }}
                onClick={() => onRemove(index)}
              />
            )}
          </Row>
        ))}
      {!disabled && (
        <Button
          type="quaternary"
          disabled={disableAdd}
          onClick={onAdd}
          style={addBtnStyle}
        >
          <span style={{ marginRight: "10px" }}>+</span>
          {t("global:add")}
        </Button>
      )}
      {disabled && !values.length && (
        <Placeholder>{t("global:noElements")}</Placeholder>
      )}
    </Container>
  );
};

export default compose(
  toClass,
  renameProp("value", "values"),
  defaultProps({
    values: [],
    emptyValue: {},
    selector: R.identity,
    deleteBtnStyle: {},
    addBtnStyle: {},
    rowStyle: {},
    keyExtractor: (_, index) => index
  }),
  withProps(({ values, emptyValue }) => ({
    disableAdd: R.any(R.equals(emptyValue), values)
  })),
  withHandlers({
    onUpdate: ({ onChange, values, selector }) => (index, value) =>
      onChange(R.update(index, selector(value), values)),
    onAdd: ({ onChange, emptyValue, values }) => () =>
      onChange(R.append(emptyValue, values)),
    onRemove: ({ onChange, values }) => index =>
      onChange(R.remove(index, 1, values))
  }),
  mapProps(R.omit(["emptyValue", "selector"]))
)(Multi);
